import * as React from "react";
const SvgDashboard = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 1.871v9.006H13.69V1.871H7.781Zm14.065 0v9.006h6.193V1.871H19.03ZM3.379 3.38h8.802v5.99H3.38V6.375Zm14.064 0h3.178v5.99h-3.178V6.375ZM1.871 13.123v9.004h6.193v-9.004H4.97Zm8.44 0v9.004H22.129v-9.004h-5.91Zm-6.932 1.508h3.178v5.99H3.379v-2.996Zm8.44 0h8.802v5.99H11.82v-2.996Z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgDashboard;
